import { Helmet } from 'react-helmet-async';
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import InfiniteScroll from 'react-infinite-scroller';
import { useNavigate } from 'react-router-dom';
import Iconify from 'src/components/iconify';

import { useGetInfinitePickems } from '@/api/pickems/getPickems.ts';

export default function LeaderboardsPage() {
  const navigate = useNavigate();

  const {
    data: pickems = [],
    isLoading,
    isError,
    hasNextPage,
    fetchNextPage,
  } = useGetInfinitePickems({ limit: 10 });

  return (
    <>
      <Helmet>
        <title>Leaderboards </title>
      </Helmet>

      <Container>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          mb={5}
        >
          <Typography variant='h4' gutterBottom>
            Leaderboards
          </Typography>
        </Stack>

        <Card>
          {isLoading ? (
            <Box
              sx={{ display: 'flex', justifyContent: 'center' }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : isError ? (
            <Box>Something goes wrong...</Box>
          ) : (
            <InfiniteScroll
              pageStart={0}
              loadMore={() => fetchNextPage()}
              hasMore={hasNextPage}
              loader={<Skeleton height='70px' />}
            >
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label='simple table'>
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Title</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pickems.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell component='th' scope='row'>
                          {row.pickem_id}
                        </TableCell>
                        <TableCell component='th' scope='row'>
                          {row.title_en}
                        </TableCell>
                        <TableCell component='th' scope='row'>
                          <Button
                            onClick={() =>
                              navigate(
                                `/dashboard/leaderboards/view?pickem_id=${row.pickem_id}`
                              )
                            }
                          >
                            <Iconify
                              icon={'eva:eye-outline'}
                              sx={{ cursor: 'pointer' }}
                            />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </InfiniteScroll>
          )}
        </Card>
      </Container>
    </>
  );
}
